import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PortalLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const portalPath = user?.role === 'partner' && user.partnerId != null ? `/portal/${user.partnerId}` : '/';

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-charcoal">
      <header className="bg-charcoal text-gold border-b-2 border-gold/40">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link
            to={portalPath}
            className="text-xl font-semibold text-gold tracking-tight hover:text-gold-light transition-colors"
          >
            The Station
          </Link>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gold/90 font-medium">Partner Portal</span>
            {user && (
              <button
                type="button"
                onClick={handleLogout}
                className="text-sm text-gold/80 hover:text-gold transition-colors"
              >
                Sign out
              </button>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-8">{children}</main>
    </div>
  );
}
